import React from 'react';

const CrumbSeparator = () => (
  <span className="search-breadcrumbs__separator">›</span>
);

export default CrumbSeparator;
